import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const onlineOrderRoutes: RouteObject[] = [
  {
    path: '/online-order/:id',
    element: lazyElement(() => import('./View')),
    handle: { crumb: () => ({ label: 'Online Order' }) },
  },
];

export default onlineOrderRoutes;
